<template>
  <footer id="footer">
    <section class="top-footer d-flex justify-content-center align-center flex-column">
      <h2 class="heading-mobile-s--light heading-xl--light line-height-mobile-42">
        Verified once. Trusted everywhere.<br>Built for modern hiring.
      </h2>
      <router-link :to="{ name: 'Contact'}">
        <Button text="Get in touch" icon="arrow-right" type="secondary" class="mt-48 mt-mobile-40 b-none" size="lg"/>
      </router-link>
    </section>
    <section class="bottom-footer">
      <section class="container">
        <section id="menu-footer" class="d-flex justify-content-between flex-mobile-column">
          <div>
            <div>
              <router-link to="/">
                <Icon href="weevs" fill="#fff" width="102" height="16"/>
              </router-link>
            </div>
            <div class="mt-44 mt-mobile-24">
              <h4 class="body-mobile-l--light heading-xs--light line-height-mobile-24">We make verification reusable<br>across the hiring journey</h4>
            </div>
            <div class="mt-44 mt-mobile-35 social-icons">
              <a href="https://matter.sg" target="_blank" rel="noopener" class="body-m--regular" style="color:rgba(255,255,255,0.5);">Built by <span style="background:linear-gradient(105deg,#1f1f1f 0%,#d31f72 22%,#f05a8c 46%,#c74f18 72%,#111111 100%);background-size:240% 240%;-webkit-background-clip:text;background-clip:text;color:transparent;font-weight:500;">Matter</span> Technologies Pte. Ltd., Singapore</a>
            </div>
          </div>

          <section class="d-flex right--footer mt-mobile-42">
            <div class="list-items">
              <h3 class="body-mobile-l--medium heading-xs--medium">Who we work with</h3>
              <ul class="mt-24 mt-mobile-16">
                <li>
                  <a href="/use-cases/financial-services" class="body-m--regular">Financial Services</a>
                </li>
                <li class="mt-24 mt-mobile-16">
                  <a href="/use-cases/technology" class="body-m--regular">Technology</a>
                </li>
                <li class="mt-24 mt-mobile-16">
                  <a href="/use-cases/government" class="body-m--regular">Government</a>
                </li>
              </ul>
            </div>

            <div class="list-items">
              <h3 class="body-mobile-l--medium heading-xs--medium">Insights</h3>
              <ul class="mt-24 mt-mobile-16">
                <li>
                  <router-link :to="{ name: 'Insights' }" class="body-m--regular">Use cases</router-link>
                </li>
                <li class="mt-24 mt-mobile-16">
                  <router-link :to="{ name: 'Insights' }" class="body-m--regular">Publications</router-link>
                </li>
              </ul>
            </div>

            <div class="list-items">
              <h3 class="body-mobile-l--medium heading-xs--medium">Company</h3>
              <ul class="mt-24 mt-mobile-16">
                <li>
                  <router-link :to="{ name: 'WeAreDifferent' }" class="body-m--regular">We are different</router-link>
                </li>
                <li class="mt-24 mt-mobile-16">
                  <router-link :to="{ name: 'Contact' }" class="body-m--regular">Careers</router-link>
                </li>
              </ul>
            </div>

            <div class="list-items">
              <h3 class="body-mobile-l--medium heading-xs--medium">Contact</h3>
              <ul class="mt-24 mt-mobile-16">
                <li>
                  <router-link :to="{ name: 'Contact' }" class="body-m--regular">Get in touch</router-link>
                </li>
                <li class="mt-24 mt-mobile-16">
                  <a @click="goToDemo()" class="body-m--regular c-pointer">Book a Demo</a>
                </li>
              </ul>
            </div>
          </section>
        </section>


      </section>
    </section>

    <section class="copyright-section">
      <section class="container d-flex justify-content-between align-center">
        <p class="caption-m--regular copyright d-flex flex-1">&copy; {{ year }} Weevs.</p>
        <p class="caption-m--regular d-flex align-center flex-1 justify-content-center">
          Made with
          <Icon href="heart" size="13" fill="#fff" class="mx-7"/>
          from <span class="caption-m--medium">&nbsp;Singapore</span>
        </p>
        <ul class="d-flex flex-1 justify-content-end">
          <li>
            <router-link :to="{ name: 'Terms' }" class="copyright caption-m--regular">
              Terms <span class="disable-font-feature">&</span> Conditions
            </router-link>
          </li>
          <li class="ml-32">
            <router-link :to="{ name: 'Privacy' }" class="copyright caption-m--regular">
              Privacy Policy
            </router-link>
          </li>
        </ul>
      </section>
    </section>
  </footer>
</template>

<script>
import Button from "@/components/Button";
import Icon from "@/components/Icon";
export default {
  components: {Icon, Button},
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  methods: {
    goToDemo() {
      sessionStorage.setItem('weevs_contact_tab', 'Book a Demo');
      this.$router.push({ name: 'Contact' });
    }
  }
}
</script>

<style scoped>
</style>
